import { render, staticRenderFns } from "./Star.vue?vue&type=template&id=13ed0ccf"
import script from "./Star.vue?vue&type=script&lang=js"
export * from "./Star.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ed0ccf')) {
      api.createRecord('13ed0ccf', component.options)
    } else {
      api.reload('13ed0ccf', component.options)
    }
    module.hot.accept("./Star.vue?vue&type=template&id=13ed0ccf", function () {
      api.rerender('13ed0ccf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/Star.vue"
export default component.exports